import { AoPath } from './ao-path';
import { PathMarkerMat } from './path-marker/path-marker-mat';
import { PathPointMat } from './path-point/path-point-mat';

export class AoPathMat extends AoPath {
  public override pathPoint: PathPointMat[];
  public override markers: PathMarkerMat[];
  public override displayedMarkers: PathMarkerMat[];

  constructor(id: string, date: Date, pathPoint: PathPointMat[]) {
    super(id, date, pathPoint);
  }

  public override generatePathMarker(pathPoint: PathPointMat): PathMarkerMat {
    return new PathMarkerMat('', pathPoint);
  }
}
